export const APP_NAME = "Network Field Service";
export const APP_LINK = "network-field-service";
